@if (contractTerm) {
  <span>{{ contractTerm }}</span>
} @else {
  -
}
